import { Section } from 'components/grid'
import React, { useContext } from 'react'
import TransformYourClassrom from 'components/arc-core/TransformYourClassroom'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function DayYear({ ...props }) {
	const { language, standard } = useContext(CoreAdoptionContext)
	const standardCapitalized = standard.toUpperCase() as 'CCSS' | 'TEKS'

	return (
		<Section className="scroll-mt-14" id={formatSectionId(props)} margin="mt-20">
			<TransformYourClassrom standard={standardCapitalized} language={language} showSupports={false} />
		</Section>
	)
}
